module.exports = __webpack_public_path__ + "static/media/iv_save_taxes.a6edc3c3.svg";